import { ROUTES } from "../../../module/constants";
import { fetchLogin } from "../module/services";
import {
  setAccessFromInternetAction,
  setToken,
  setTriggerErrorModal,
} from "../../../App/module/actions";
import {
  setFirstAccessAction,
  setOldPasswordAction,
  setTempTokenAction,
} from "../module/actions";
import { SubmissionError } from "redux-form";
import { TOKEN_SCOPE } from "../module/constants";
import { useDispatch } from "react-redux";

const onSubmit = (values: any, dispatch: any, props: any) => {
  const { user, pwd } = values;
  const fetchLoginAPI = (values: any) => fetchLogin(values).toPromise();
  const { changeLocation } = props;
  return new Promise((resolve, reject) => {
    fetchLoginAPI(values)
      .then((res: any) => {
        const { access_token, token_type, scope } = res;

        if (scope === TOKEN_SCOPE.FORCE_CHG_PWD) {
          dispatch(setFirstAccessAction(true));
          dispatch(setOldPasswordAction(pwd));
          dispatch(setTempTokenAction(`${token_type} ${access_token}`));
        } else if (scope === TOKEN_SCOPE.INTERNET_ACCESS) {
          dispatch(setAccessFromInternetAction(true));
          sessionStorage.setItem("token", `${token_type} ${access_token}`);
        } else {
          sessionStorage.setItem("token", `${token_type} ${access_token}`);
          dispatch(setTriggerErrorModal(false));
          dispatch(setToken(`${token_type} ${access_token}`));
          changeLocation(ROUTES.WELCOME);
        }
        resolve(values);
      })
      .catch((err: any) => {
        return reject(
          new SubmissionError({
            user: err,
            pwd: err,
            _error: true,
          })
        );
      });
  });
};

export default onSubmit;
